import { useEffect, useState } from 'react';
import { fetchGlobalMsg } from '../utils';
import { useSharedGlobalState } from './useSharedGlobal';
import { actions } from '@core/shared';
import { useFirstPermissionRouter } from './useFirstPermissionRouter';
import { useLocation } from 'react-router-dom';
const Status = {
    loading: 'loading',
    read: 'read',
};
export function useGlobalPermissionState(systemId, routes) {
    const [status, setStatus] = useState(Status.loading);
    const { setFirstPerRouter } = useFirstPermissionRouter({ systemId, routes });
    const location = useLocation();
    const { _initPermissionList, _initStateByObj, permissionListMap } = useSharedGlobalState();
    const setReadStatus = () => {
        setStatus(Status.read);
    };
    const setLoadingStatus = () => {
        setStatus(Status.loading);
    };
    useEffect(() => {
        setLoadingStatus();
        if (systemId) {
            const requestGlobalMsg = async () => {
                const data = await fetchGlobalMsg(systemId || '');
                const { permissionList, ...rest } = data || {};
                _initPermissionList(permissionList);
                _initStateByObj({ ...rest });
                if (sessionStorage.getItem('__init')) {
                    setReadStatus();
                    return;
                }
                else {
                    setFirstPerRouter(rest.resourceList || []);
                    sessionStorage.setItem('systemId', systemId);
                    sessionStorage.setItem('__init', 'true');
                }
            };
            requestGlobalMsg().finally(() => {
                setReadStatus();
            });
        }
        else {
            setReadStatus();
        }
        return () => {
            sessionStorage.removeItem('__init');
            sessionStorage.removeItem('systemId');
        };
    }, [systemId]);
    useEffect(() => {
        actions.setPermissionMap(permissionListMap);
    }, [permissionListMap]);
    useEffect(() => {
        _initStateByObj({ location });
    }, [location.pathname]);
    return {
        status,
    };
}
